import React from 'react'
import {broadcast, listen, stop_listen, post_gql, INIT_POLYGON_SETTINGS, INIT_TEXT_SETTINGS} from '../../utils'
import {GeoJsonLayer} from '@deck.gl/layers';
import ColorPicker from '../colorpicker'
import * as turf from '@turf/turf'

class LayerEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      object_id: false,
      mouse_down_coords: false,
      container_mouse_coords: false,
      top: 10,
      left: 30,
      user_id: null,
      hidden: false,
      fill_hidden: false,
      border_hidden: false,
      pattern_hidden: false,
      polygon_settings: INIT_POLYGON_SETTINGS,
      text_settings: INIT_TEXT_SETTINGS,
      listners: []
    }
  }

  close_editor(){
    this.setState({object_id: false, polygon_settings: {radius: this.state.polygon_settings.radius}})
    broadcast("remove_layer", "bboxPolygon")
    broadcast("toolbar_mode_change", {mode: 'cursor'})
    broadcast("layer_edit", {id: false, type: "polygon"})
  }

  componentDidMount(){
    const listners = [
      {type: "containter_onMouseMove", fnc: ({detail}) => {
        this.setState({container_mouse_coords: [detail.clientX, detail.clientY]})
        if (!!this.state.mouse_down_coords)
          this.setState({
            top: this.state.top + (detail.clientY - this.state.mouse_down_coords[1]),
            left: this.state.left + (detail.clientX - this.state.mouse_down_coords[0]),
            mouse_down_coords: [detail.clientX, detail.clientY]
          })
      }},
      {type: "toolbar_delete", fnc: ({detail}) => {
        if (this.state.object_id) {
          post_gql(
            `mutation {geomapLayerDelete(layer_id: ${this.state.object_id})}`,
            resp => {
              broadcast("remove_layer", this.state.object_id)
              this.close_editor()
            }
          )
        }
      }},
      {type: "map_click", fnc: ({detail}) => {
        // console.log("map_click", detail)
        if (detail.mode === "cursor") {
          const obj = detail.event.object
          if (obj && !obj.bbox && !!obj.properties.polygon_settings) {
            this.setState({object_id: obj.properties.id, polygon_settings: {...obj.properties.polygon_settings, radius: this.state.polygon_settings.radius}})

            const bboxPolygon = turf.bboxPolygon(turf.bbox(obj))

            const layer = new GeoJsonLayer({
              id: `bboxPolygon`, data: bboxPolygon, getFillColor: [0, 0, 0, 0], getFillOpacity: 0,
              getLineWidth: 4, lineWidthUnits: 'pixels',  getLineColor: [168, 0, 0, 256]
            })

            broadcast("add_or_replace_layer", layer)
            broadcast("layer_edit", {id: obj.properties.id, type: "polygon"})
          } else {
            if (this.state.object_id) {
              this.setState({object_id: false, polygon_settings: {radius: this.state.polygon_settings.radius}})
              broadcast("remove_layer", "bboxPolygon")
            }
          }
        }
      }},
      {type: "polygon_radius", fnc: ({detail}) => {
        this.setState({polygon_settings: {...this.state.polygon_settings, radius: detail.value}})
      }},
      {type: "update_polygon_opacity", fnc: ({detail}) => {
        const settings = {...this.state.polygon_settings, opacity: detail.value}
        this.setState({polygon_settings: settings})
      }},
      {type: "update_polygon_color", fnc: ({detail}) => {
        const settings = {...this.state.polygon_settings, color: detail.value}
        this.setState({polygon_settings: settings})
      }},
      {type: "update_polygon_border_width", fnc: ({detail}) => {
        const settings = {...this.state.polygon_settings, border_width: detail.value}
        this.setState({polygon_settings: settings})
      }},
      {type: "update_polygon_border_opacity", fnc: ({detail}) => {
        const settings = {...this.state.polygon_settings, border_opacity: detail.value}
        this.setState({polygon_settings: settings})
      }},
      {type: "update_polygon_border_color", fnc: ({detail}) => {
        const settings = {...this.state.polygon_settings, border_color: detail.value}
        this.setState({polygon_settings: settings})
      }},
      {type: "update_polygon_pattern", fnc: ({detail}) => {
        const settings = {...this.state.polygon_settings, pattern: detail.value}
        this.setState({polygon_settings: settings})
      }},
      {type: "update_polygon_pattern_scale", fnc: ({detail}) => {
        const settings = {...this.state.polygon_settings, pattern_scale: detail.value}
        this.setState({polygon_settings: settings})
      }},
      {type: "add_or_replace_layer", fnc: ({detail}) => {
        if (detail.id === this.state.object_id) {
          const obj = detail.props.data
          const bboxPolygon = turf.bboxPolygon(turf.bbox(obj))
          const layer = new GeoJsonLayer({
            id: `bboxPolygon`, data: bboxPolygon, getFillColor: [0, 0, 0, 0], getFillOpacity: 0,
            getLineWidth: 4, lineWidthUnits: 'pixels', getLineColor: [168, 0, 0, 256]
          })

          broadcast("add_or_replace_layer", layer)
        }
      }},
    ]

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  componentWillUnmount(){this.state.listners.forEach(l => stop_listen(l.type, l.fnc))}

  render() {
    const object_id = this.state.object_id
    const user_id = this.props.user_id

    if (object_id){
      return(
        <div className="polygon-tool" style={{top: this.state.top, left: this.state.left}}>
          <div
            className="tool-header"
            onMouseDown={e => this.setState({mouse_down_coords: this.state.container_mouse_coords})}
            onMouseUp={e => this.setState({mouse_down_coords: false})}
          >
            <span className="tool-header-title">&nbsp;редактирование полигона</span>
            <div className="tool-header-btns">
              <span
                className="tool-header-btn"
                onClick={() => this.setState({hidden: !this.state.hidden})}
              >{this.state.hidden ? "▾" : "▸"}</span>
              <span
                className="tool-header-btn"
                style={{transform: `rotateZ(45deg)`}}
                onClick={() => this.close_editor()}
              >+</span>
            </div>
          </div>
          {
            this.state.hidden ? null :
            <div className="tool-body">
              <div className="tool-body-header">
                <span className="tool-header-title">&nbsp;&nbsp;заливка</span>
                <span
                  className="tool-header-btn"
                  onClick={() => this.setState({fill_hidden: !this.state.fill_hidden})}
                >{this.state.fill_hidden ? "▾" : "▸"}&nbsp;</span>
              </div>
              {
                this.state.fill_hidden ? null :
                  <div>
                    <div className="tool-input-cont">
                      <ColorPicker user_id={user_id} object_id={object_id} broadcast_type="update_polygon_color"/>
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">цвет</span>
                      <input
                        className="tool-input"
                        value={this.state.polygon_settings.color}
                        style={{backgroundColor: this.state.polygon_settings.color, color: 'white', textShadow: '0px 0px 4px black'}}
                        onChange={e => broadcast("update_polygon_color", {object_id: object_id, user_id: user_id, value: e.currentTarget.value})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">радиус</span>
                      <input
                        className="tool-input"
                        value={this.state.polygon_settings.radius}
                        onChange={e => broadcast("polygon_radius", {object_id: object_id, user_id: user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">прозрачность</span>
                      <input
                        className="tool-input"
                        value={this.state.polygon_settings.opacity}
                        onChange={e => broadcast("update_polygon_opacity", {object_id: object_id, user_id: user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                  </div>
              }
              <div className="tool-body-header">
                <span className="tool-header-title">&nbsp;&nbsp;паттерн</span>
                <span
                  className="tool-header-btn"
                  onClick={() => this.setState({pattern_hidden: !this.state.pattern_hidden})}
                >{this.state.pattern_hidden ? "▾" : "▸"}&nbsp;</span>
              </div>
              {
                this.state.pattern_hidden ? null :
                  <div style={{maxHeight: '200px', overflowY: 'auto'}}>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">масштабирование</span>
                      <input
                        className="tool-input"
                        value={this.state.polygon_settings.pattern_scale}
                        onChange={e => broadcast("update_polygon_pattern_scale", {object_id: object_id, user_id: user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div
                      className={`tool-input-img-cont ${this.state.polygon_settings.pattern === 'none' ? 'active' : ''}`}
                      onClick={() => broadcast("update_polygon_pattern", {object_id: object_id, user_id: user_id, value: 'none'})}
                    >
                      <span className="tool-input-label">без паттерна</span>
                      <img style={{width: "64px", height: "64px"}} alt="" />
                    </div>
                    <div
                      className={`tool-input-img-cont ${this.state.polygon_settings.pattern === 'dots' ? 'active' : ''}`}
                      onClick={() => broadcast("update_polygon_pattern", {object_id: object_id, user_id: user_id, value: 'dots'})}
                    >
                      <span className="tool-input-label">точка</span>
                      <img src="/dots.png" style={{width: "64px", height: "64px"}} alt="" />
                    </div>
                    <div
                      className={`tool-input-img-cont ${this.state.polygon_settings.pattern === 'hatch' ? 'active' : ''}`}
                      onClick={() => broadcast("update_polygon_pattern", {object_id: object_id, user_id: user_id, value: 'hatch'})}
                    >
                      <span className="tool-input-label">ромб</span>
                      <img src="/hatch.png" style={{width: "64px", height: "64px"}} alt="" />
                    </div>
                    <div
                      className={`tool-input-img-cont ${this.state.polygon_settings.pattern === 'x1' ? 'active' : ''}`}
                      onClick={() => broadcast("update_polygon_pattern", {object_id: object_id, user_id: user_id, value: 'x1'})}
                    >
                      <span className="tool-input-label">косая черта 1</span>
                      <img src="/x1.png" style={{width: "64px", height: "64px"}} alt="" />
                    </div>
                    <div
                      className={`tool-input-img-cont ${this.state.polygon_settings.pattern === 'x2' ? 'active' : ''}`}
                      onClick={() => broadcast("update_polygon_pattern", {object_id: object_id, user_id: user_id, value: 'x2'})}
                    >
                      <span className="tool-input-label">косая черта 2</span>
                      <img src="/x2.png" style={{width: "64px", height: "64px"}} alt="" />
                    </div>
                  </div>
              }

              <div className="tool-body-header">
                <span className="tool-header-title">&nbsp;&nbsp;граница</span>
                <span
                  className="tool-header-btn"
                  onClick={() => this.setState({border_hidden: !this.state.border_hidden})}
                >{this.state.border_hidden ? "▾" : "▸"}&nbsp;</span>
              </div>
              {
                this.state.border_hidden ? null :
                  <div>
                    <div className="tool-input-cont">
                      <ColorPicker user_id={user_id} object_id={object_id} broadcast_type="update_polygon_border_color"/>
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">цвет</span>
                      <input
                        className="tool-input"
                        value={this.state.polygon_settings.border_color}
                        style={{backgroundColor: this.state.polygon_settings.border_color, color: 'white', textShadow: '0px 0px 4px black'}}
                        onChange={e => broadcast("update_polygon_border_color", {object_id: object_id, user_id: user_id, value: e.currentTarget.value})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">толщина</span>
                      <input
                        className="tool-input"
                        value={this.state.polygon_settings.border_width}
                        onChange={e => broadcast("update_polygon_border_width", {object_id: object_id, user_id: user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">прозрачность</span>
                      <input
                        className="tool-input"
                        value={this.state.polygon_settings.border_opacity}
                        onChange={e => broadcast("update_polygon_border_opacity", {object_id: object_id, user_id: user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                  </div>
              }
            </div>
          }
        </div>
      )
    } else {
      return(null)
    }
  }
}

export default LayerEditor;
